<template>
    <b-row class="team" align-h="start">
        <b-col cols="12"  lg="7" class="img-team-movil">
            <b-row>
                <b-col class="col-sm-11 col-lg-12 mx-auto">
                <img class="team-imagen" :src="srcImagen" alt="Team Image img" >
                <img class="team-imagen-movil" src="@/assets/images/we/team.png" alt="Team Img">
                </b-col>
            </b-row>
            
        </b-col>
        <b-col cols="12" class="team-content-titulo row mx-auto mb-5" lg="5">
            <p class="team-titulo col-12 mx-auto" style="font-size: 35px;" v-html="content.titulo"></p>
            <p class="team-content col-12 mx-auto" v-html="content.content"></p>
            <!-- <div class="team-space-button mt-4 pb-4">
                <button class="button-primary-global" @click="goRouter('/contacto')">
                    <span class="button-text-global">Quiero ser GOX
                        <img src="@/assets/images/arrow_left.svg">
                    </span>
                </button>
            </div> -->
        </b-col>
        <b-col cols="12"  lg="7" class="img-team-desktop">
            <b-row>
                <b-col class="col-sm-11 col-lg-12 mx-auto">
                <img class="team-imagen" :src="srcImagen" alt="Team Image img">
                </b-col>
            </b-row>
            
        </b-col>
    </b-row>
</template>
<script>
    export default {
        name: 'section-team',
        components: {},
        props: {
            content: Object
        },
        computed: {
            srcImagen() {
                let src = require('@/assets/images/we/' + this.content.imagen)
                return src
            }
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
            }
        }
    }
</script>
<style scoped>


.img-team-movil {
    display: none;
}

.team-imagen-movil {
    display: none;
}

@media (max-width: 600px) {
    .img-team-movil {
    display: flex;
    height: 257px;
    padding-left: 0px;
    padding-right: 0px;
    border-radius: 0px;
    }

    .img-team-desktop {
        display: none;
    }

    .team-imagen-movil {
        display: flex;
    }

    .team-imagen{
        display: none;
        padding: 0px;
    }

    .team {
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 0px;
    }

    .team-content {
        margin-top: 1rem;
    }
}

</style>